import { render } from "./FormularioFamilias.vue?vue&type=template&id=46174a44&ts=true"
import script from "./FormularioFamilias.vue?vue&type=script&lang=ts"
export * from "./FormularioFamilias.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__